import { render } from "./App.vue?vue&type=template&id=13f34ea7&bindings={\"setLeagueId\":\"setup\",\"store\":\"setup\"}"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script